module.exports = __webpack_public_path__ + "d56541393795dca7680ace607c193da4.MP3";